import { TriangleAlert } from "lucide-react";
import { Component, type ReactNode } from "react";

import { Button } from "@/components/ui/button";
import { operationFeedbackClass } from "@/components/ui/operation-feedback";
import { cn } from "@/lib/utils";

// TUT-496 — o que a pessoa vê quando o pedaço da paleta (ou dos diálogos de
// criar) não carrega: aba aberta antes de um deploy, ou rede que caiu. As demais
// páginas lazy da casa caem no `ErrorBoundary` do app inteiro; aqui o defeito é
// local (a paleta é um recurso a mais, não a tela), então o erro também é: um
// aviso discreto no pé da janela, com "Tentar de novo", e o resto da tela segue.

interface Props {
  children: ReactNode;
  /** O que não carregou, em uma frase ("Não foi possível abrir a busca."). */
  mensagem: string;
  /** Refaz o `import()`; o chamador troca a `key` desta fronteira. */
  aoTentar: () => void;
  aoFechar: () => void;
}

export class FronteiraDaCarga extends Component<Props, { falhou: boolean }> {
  override state = { falhou: false };

  static getDerivedStateFromError() {
    return { falhou: true };
  }

  override render() {
    if (!this.state.falhou) return this.props.children;
    return (
      <div
        role="alert"
        data-slot="falha-da-carga"
        className={cn(
          operationFeedbackClass("error"),
          "fixed bottom-4 left-1/2 z-[80] mb-0 w-max max-w-[calc(100vw-2rem)] -translate-x-1/2",
        )}
      >
        <TriangleAlert aria-hidden="true" />
        <span>{this.props.mensagem}</span>
        <span className="flex gap-1">
          <Button type="button" variant="vidro" size="sm" onClick={this.props.aoTentar}>
            Tentar novamente
          </Button>
          <Button type="button" variant="vidro" size="sm" onClick={this.props.aoFechar}>
            Fechar
          </Button>
        </span>
      </div>
    );
  }
}
